import React from 'react'

function SocialIcons({facebook,instagram,youtube,pinterest}) {
    return(
        <div className="socialicons">
            {facebook && facebook !== "" ? 
                <a href={facebook} target="_blank" style={{padding:"5px",color:"black"}}>
                <i className="fa fa-facebook"></i>
                </a>:null}
            {instagram && instagram !== "" ? 
            <a href={instagram} target="_blank"  style={{padding:"5px",color:"black"}}>
                <i className="fa fa-instagram"></i>
            </a>
            :null}
            {youtube && youtube !== "" ? 
            <a href={youtube} target="_blank" style={{padding:"5px",color:"black"}}>
                <i className="fa fa-youtube"></i>
            </a>
            :null}
            {pinterest && pinterest !== "" ? 
            <a href={pinterest} target="_blank" style={{padding:"5px",color:"black"}}>
                <i className="fa fa-pinterest"></i>
            </a>
            :null}
        </div>
    )

}
export default SocialIcons;